import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { userDeposit } from "../../../../../../../common/types/AdminInfo/userDeposit";
import { AdminPanel } from "../../../../../../../services";
import "./Deposit.scss";
import { PayemntItem } from "./DepositUi/PayemntItem/PayemntItem";

const Deposit = () => {
  const [paymentMethods, setPaymentMethods] = useState<userDeposit[] | []>([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    userDeposit | any
  >();
  const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [passportUnvalid, setPassportUnvalid] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (inputValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
    if (Number(inputValue) < Number(selectedPaymentMethod?.currencies[0].min)) {
      setButtonSubmitDisabled(true);
    }
    if (Number(inputValue) > Number(selectedPaymentMethod?.currencies[0].max)) {
      setButtonSubmitDisabled(false);
    }
  };

  const handleMoveToPay = () => {
    async function getPaymentUrl() {
      const res = await AdminPanel.userPay({
        data: {
          amount: Number(inputValue) * 100,
          currency: "TRY",
          payment_aggregator_id: selectedPaymentMethod?.payment_aggregator_id,
          service_id: selectedPaymentMethod?.service_id,
        },
        params: "",
      });
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      if (res.data === "validation.passportError") {
        setPassportUnvalid(true);
      } else {
        window.open(res.data.redirectUrl, "_blank");
      }
    }
    async function getPaymentManualUrl() {
      const res = await AdminPanel.userPayManual({
        data: {
          amount: Number(inputValue) * 100,
          currency: "TRY",
          payment_aggregator_id: selectedPaymentMethod?.payment_aggregator_id,
          service_id: selectedPaymentMethod?.service_id,
        },
        params: "",
      });
      window.open(res.data.redirectUrl, "_blank");
    }
    if (selectedPaymentMethod?.service_id === "77777") {
      getPaymentManualUrl();
    } else {
      getPaymentUrl();
    }
  };

  useEffect(() => {
    if (
      Number(inputValue) <= Number(selectedPaymentMethod?.currencies[0].max)
    ) {
      setButtonSubmitDisabled(false);
    } else {
      setButtonSubmitDisabled(true);
    }
  }, [buttonSubmitDisabled, inputValue, selectedPaymentMethod]);

  useEffect(() => {
    async function getPayemntMethods() {
      const res = await AdminPanel.userDeposit("?filter[type]=1");
      setPaymentMethods(res.data);
      setSelectedPaymentMethod(res.data[0]);
    }
    getPayemntMethods();
  }, []);

  return (
    <>
      <div className="overlay-header">{t("admin.Deposit")}</div>
      <div className="dep-w-info-bc" data-scroll-lock-scrollable="">
        <div className="m-block-nav-items-bc">
          {paymentMethods.map((item) => {
            return (
              <PayemntItem
                key={item.id}
                paymentInfo={item}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                setButtonSubmitDisabled={setButtonSubmitDisabled}
                setInputValue={setInputValue}
              />
            );
          })}
        </div>
      </div>
      <div className="payment-info-bc" data-scroll-lock-scrollable="">
        <div className="description-c-row-bc deposit">
          <div className="description-c-row-column-bc texts">
            <div className="description-c-row-c-title-bc ">
              <div className="description-c-r-c-t-column-bc">
                <span
                  className="description-title  ellipsis"
                  title="Payment name"
                >
                  {t("admin.Paymentname")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.name}
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Fee">
                  {t("admin.Fee")}
                </span>
                <span className="description-value"></span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span
                  className="description-title  ellipsis"
                  title="Process Time"
                >
                  {t("admin.ProcessTime")}
                </span>
                <span className="description-value">
                  {/* {mockPaymentData[selectedPaymentMethod]?.ProcessTime} */}
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Min">
                  {t("admin.Min")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.currencies[0].min} ₺
                </span>
              </div>
              <div className="description-c-r-c-t-column-bc">
                <span className="description-title  ellipsis" title="Max">
                  {t("admin.Max")}
                </span>
                <span className="description-value">
                  {selectedPaymentMethod?.currencies[0].max} ₺
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="deposit-method-description HedefHavale">
          {selectedPaymentMethod?.description}
        </div>
        <div className="withdraw-form-l-bc">
          <div>
            <div className="u-i-p-control-item-holder-bc">
              <div
                className={`form-control-bc default ${
                  inputFocused ? "focused" : ""
                }`}
              >
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control-input-bc"
                    name="value"
                    defaultValue=""
                    value={inputValue}
                    onChange={onChangeInput}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">count</span>
                </label>
              </div>
            </div>
            <div className="u-i-p-c-footer-bc">
              <button
                className="btn a-color deposit "
                title="DEPOSIT"
                disabled={buttonSubmitDisabled}
                onClick={handleMoveToPay}
              >
                <span>{t("admin.Deposit")}</span>
              </button>
            </div>
            {passportUnvalid && (
              <div className="unvalid-passport">
                {t("admin.Notavalidpassport")}!!!
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { Deposit };
